export default "__VITE_ASSET__nt5O0Tm7__"